import { bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowClass } from '../../dbschema/bl_fi_my_einvoice_from_irb_match_gen_doc_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class FromIRBMatchGenDocQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_match_gen_doc_queue: bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowClass = new bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowClass();
}
